import { Injectable } from '@angular/core';
import { RestService } from 'src/app/core/services/rest.service';
import { GeneralConstants } from '../constants/general.constants';
import { QRResponse } from '../models/payment-order/qr.response';
import { CreatePaymentRequest } from '../models/payment-order/create-payment.request';
import { GatewayParametersModel } from '../models/payment-order/gateway-parameters.model';
import { OrderPaymentRequest } from '../models/payment-order/order-payment.request';
import { NotificationService } from './notification.service';
import { VirtualAccountBalanceModel } from '../models/virtual-account-balance.model';
import { PaymentOrderResponseModel } from '../models/response/payment-order-response.model';
import { PaymentQrModel } from '../models/payment-qr.model';

@Injectable()
/**
 * Para pagos a partir de una orden de pago
 */
export class PayService {
  constructor(private restService: RestService, private notificationService: NotificationService) {}

  public async getPaymentOrder(uuid: string): Promise<PaymentOrderResponseModel> {
    try {
      const response = await this.restService.get(GeneralConstants.getPaymentOrder + '/' + uuid, {});
      return <PaymentOrderResponseModel>response.object;
    } catch (error) {
      return Promise.reject(error.message);
    }
  }

  /**
   * @todo This method must to be sanitized, for allowed dues feature
   * @implemented YACA-13 Implementar gateway de pago Decidir
   * @author Félix E. Solórzano C.
   */
  toCreatePaymentRequestDTO(
    qrResponse: QRResponse,
    paymentMethodId: number,
    paymentMethodTypeId: number,
    uuid: string,
    montoIngresable?: string
  ): CreatePaymentRequest {
    let request = new CreatePaymentRequest();
    request.idMedioPago = paymentMethodId;
    request.idPaymentRequest = qrResponse.idPaymentRequest;
    request.idTipoMedioPago = paymentMethodTypeId;
    request.uuid = uuid;
    request.cvu = qrResponse.cvu;
    if (montoIngresable != undefined) {
      request.montoIngresable = montoIngresable;
    }
    return request;
  }

  /**
   * Solicita la creación de un pago pendiente a Yacaré-Core;
   * @param request Datos para crear un pago pendiente;
   * @type Async
   * @returns Promise<CreatePaymentResponseModel>
   */
  public createPendingPayment(request: CreatePaymentRequest): Promise<GatewayParametersModel> {
    return new Promise((resolve, reject) => {
      this.restService
        .post(GeneralConstants.createPendingPayment, request)
        .then((response) => {
          resolve(<GatewayParametersModel>response.object.parametros);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  /**
   * Solicita la creación de un pago pendiente a Yacaré-Core;
   * @param request Datos para crear un pago pendiente;
   * @type Async
   * @returns Promise<CreatePaymentResponseModel>
   */
  public createPaymentOrder(request: OrderPaymentRequest): Promise<string> {
    return new Promise((resolve, reject) => {
      this.restService
        .post(GeneralConstants.createPaymentOrder, request)
        .then((response) => {
          resolve(<string>response.object.paymentURL);
        })
        .catch((error) => {
          throw this.notificationService.showError(error.message, 'Link de Pago');
          reject();
        });
    });
  }

  public createPaymentOrderQr(request: PaymentQrModel): Promise<string> {
    return new Promise((resolve, reject) => {
      this.restService
        .post(GeneralConstants.createPaymentOrder, request)
        .then((response) => {
          resolve(<string>response.object.paymentURL);
        })
        .catch((error) => {
          throw this.notificationService.showError(error.message, 'Link de Pago');
          reject();
        });
    });
  }

  public getVirtualAccountBalance(): Promise<VirtualAccountBalanceModel> {
    return new Promise((resolve, reject) => {
      this.restService
        .get(GeneralConstants.virtualAccountBalance)
        .then((response) => {
          let balance = new VirtualAccountBalanceModel();

          balance.generalBalance = response.object.generalBalance;
          balance.availableBalance = response.object.availableBalance;
          balance.toCollectBalance = response.object.toCollectBalance;

          resolve(balance);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }
}
